import React, { useEffect, useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CompanyCreate } from '../../../schema/company';
import { api } from '../../../api';

const EditCompany: React.FC = () => {
  const { company_id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<CompanyCreate>({
    company_code: '',
    company_name: '',
    company_name_en: '',
    company_type_id: '',
    company_id: '',
    phone_number: '',
    email: '',
    address: ''
  });
  const [company_data, setCompany] = useState<CompanyCreate>({
    company_code: '',
    company_name: '',
    company_name_en: '',
    company_type_id: '',
    company_id: '',
    phone_number: '',
    email: '',
    address: ''
  });

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (
      form.company_code != company_data.company_code ||
      form.company_id != company_data.company_id
    ) {
      setOpenConfirmEditCodeDialog(true);
    } else {
      setOpenConfirmDialog(true);
    }
  };

  const send_data = () => {
    api.put<CompanyCreate>(`/company/${company_id}`, form).then(() => {
      navigate('/company-management');
    });
  };
  const handleOnChangeNoSpace = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regexDigit = event.target.value.match(/[\dA-Za-z]+/g);
    const digitStr = regexDigit ? regexDigit.join('') : '';
    setForm({ ...form, [event.target.name]: digitStr });
  };

  const handleOnChangeOnlyNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regexDigit = event.target.value.match(/\d+/g);
    const digitStr = regexDigit ? regexDigit.join('') : '';
    setForm({ ...form, [event.target.name]: digitStr });
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };
  const handleOnSelectChange = (event: SelectChangeEvent) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmEditCodeDialog, setOpenConfirmEditCodeDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  useEffect(() => {
    api.get<CompanyCreate>(`/company/${company_id}`).then((res) => {
      const { data } = res;
      setForm(data);
      setCompany(data);
    });
  }, []);

  const handleDelete = () => {
    api.delete<CompanyCreate>(`/company/${company_id}`).then(() => {
      navigate('/company-management');
    });
  };

  return (
    <RootContainer>
      <PageHeader text="แก้ไขข้อมูลบริษัท" />
      <Button component={Link} to="/company-management" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        จัดการข้อมูลบริษัท
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ p: 2 }}>
          เพิ่มข้อมูลบริษัท
        </Typography>
        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="รหัสบริษัท"
                variant="outlined"
                placeholder="รหัสบริษัท"
                name="company_code"
                value={form.company_code}
                onChange={handleOnChangeNoSpace}
                autoComplete="off"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="หมายเลขผู้เสียภาษี"
                variant="outlined"
                placeholder="หมายเลขผู้เสียภาษี"
                name="company_id"
                value={form.company_id}
                onChange={handleOnChangeOnlyNumber}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="ชื่อบริษัท"
                variant="outlined"
                placeholder="ชื่อบริษัท"
                name="company_name"
                value={form.company_name}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                label="ชื่อบริษัท (ภาษาอังกฤษ)"
                variant="outlined"
                placeholder="ชื่อบริษัท (ภาษาอังกฤษ)"
                name="company_name_en"
                value={form.company_name_en}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="company-type">ประเภทบริษัท</InputLabel>
                <Select
                  required
                  labelId="company-type"
                  label="ประเภทบริษัท"
                  name="company_type_id"
                  variant="outlined"
                  onChange={handleOnSelectChange}
                  value={form.company_type_id}
                  autoComplete="off"
                >
                  <MenuItem value="2">ประจำ</MenuItem>
                  <MenuItem value="3">ชั่วคราว</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ที่อยู่"
                variant="outlined"
                placeholder="ที่อยู่"
                name="address"
                value={form.address}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เบอร์โทรศัพท์"
                variant="outlined"
                placeholder="เบอร์โทรศัพท์"
                name="phone_number"
                value={form.phone_number}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="อีเมล"
                variant="outlined"
                placeholder="อีเมล"
                name="email"
                value={form.email}
                onChange={handleOnChange}
                autoComplete="off"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={6}>
              <Button variant="outlined" color="error" onClick={() => setOpenDeleteDialog(true)}>
                ลบข้อมูล
              </Button>
            </Grid>
            <Grid container item xs={6} sx={{ justifyContent: 'end' }}>
              <Button type="submit" variant="contained" color="primary">
                แก้ไข
              </Button>
            </Grid>
          </Grid>
        </Form>
        {/* edit */}
        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
            ยืนยันการแก้ไขข้อมูล
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ท่านต้องการยืนยันการแก้ไขข้อมูล ใช่หรือไม่
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 2 }}>
            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
              color="primary"
              autoFocus
            >
              ยกเลิก
            </Button>

            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
                send_data();
              }}
              color="error"
              autoFocus
            >
              ยืนยันการแก้ไข
            </Button>
          </DialogActions>
        </Dialog>

        {/* edit code or id */}
        <Dialog
          open={openConfirmEditCodeDialog}
          onClose={() => setOpenConfirmEditCodeDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
            มีการแก้ไขรหัสบริษัท หรือ หมายเลขผู้เสียภาษี !
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" color="error">
              การแก้ไขรหัสบริษัทหรือเลขทะเบียนนิติบุคคล
              อาจส่งผลให้รายการการทำธุรกรรมภายใต้เลขเดิมในระบบอื่นๆของ ปตท. ไม่สามารถใช้งานได้
              ท่านยังคงประสงค์จะทำรายการเปลี่ยนแปลงอยู่ ใช่หรือไม่
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 2 }}>
            <Button
              onClick={() => {
                setOpenConfirmEditCodeDialog(false);
              }}
              color="primary"
              autoFocus
            >
              ยกเลิก
            </Button>

            <Button
              onClick={() => {
                setOpenConfirmEditCodeDialog(false);
                send_data();
              }}
              color="error"
              autoFocus
            >
              ยืนยันการแก้ไข
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle sx={{ px: 3 }} id="alert-dialog-title" variant="h5">
            ยืนยันการลบข้อมูล
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              หากลบข้อมูลบริษัทแล้วจะไม่สามารถเรียกคืนรายการนี้ได้อีก
              พนักงานภายใต้สังกัดบริษัทนี้จะถูกย้ายไปยัง `ไม่มีบริษัทในสังกัด`
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ pb: 2, px: 2 }}>
            <Button
              onClick={() => {
                setOpenDeleteDialog(false);
              }}
              color="primary"
              autoFocus
            >
              ยกเลิก
            </Button>

            <Button
              onClick={() => {
                setOpenDeleteDialog(false);
                handleDelete();
              }}
              color="error"
              autoFocus
            >
              ยืนยันการลบข้อมูล
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </RootContainer>
  );
};

export default EditCompany;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
